import { useEffect } from 'react'
import {
  ControllerProps,
  Controller as ControllerRHF,
  FieldPath,
  FieldValues,
} from 'react-hook-form'

import { usePersistentState } from '../persistentState'
import { useCurrentPage, useEditMode } from 'directFlow/utils'

export const Controller = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  render,
  ...props
}: ControllerProps<TFieldValues, TName>) => {
  const isEditMode = useEditMode()
  const currentPage = useCurrentPage()
  const persistentState = usePersistentState()
  const name = props.name

  useEffect(() => {
    if (isEditMode) {
      return
    }

    return () => persistentState.removeField(currentPage, name)
  }, [])

  const renderProps: ControllerProps<TFieldValues, TName>['render'] = ({
    field,
    ...renderParams
  }) => {
    const { onChange } = field

    const handleChange: typeof onChange = (...event) => {
      onChange(...event)
      if (!isEditMode) {
        const value = event[0]
        persistentState.updateField(currentPage, name, value)
      }
    }

    const enhancedField = {
      ...field,
      onChange: handleChange,
    }

    return render({ field: enhancedField, ...renderParams })
  }

  return <ControllerRHF render={renderProps} {...props} shouldUnregister />
}
